import React, { useState } from "react";
import Modal from "../common/modal";
import CrossIcon from "../../images/login/latestCrossIcon.svg";

import "./styles.css";

const EmailUpdatePopup = ({ email, onClose, onSubmit, emailType }) => {
  const [newEmail, setNewEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const messages = {
    notification: "We are transitioning away from phone number-based login for the Dashboard. Please confirm if we should use the following email ID for your login.",
    existing: "We are transitioning away from phone number-based login for the Dashboard. Please use the following email ID to login.",
    new: "We are transitioning away from phone number-based login for the Dashboard. Please enter the email ID you would like to use for login."
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (type) => {
    if (type !== "confirm" && !validateEmail(newEmail)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      const result = await onSubmit(type === "confirm" ? email : newEmail);
      const { v4RegisterResponse = {}, responseCode } = result || {};
      if (v4RegisterResponse && v4RegisterResponse.responseCode === "01") {
        setSuccessMessage(
          "A password reset link has been sent to your email. Please check your inbox to set your password and complete the registration."
        );
        setIsSubmitted(true);
      } else if (responseCode == 448) {
        setError(
          result.message ||
            "This email is already registered as a merchant. Please use a different email address."
        );
      } else if (responseCode >= 400) {
        setError(result.message || "Failed to register email. Please try again.");
      }
    } catch (error) {
      setError("Failed to register email. Please try again.");
    }
  };

  return (
    <Modal overlay>
      <div className="backgroundCloseFrame">
        <img className="closeModal" onClick={onClose} src={CrossIcon} alt="Close" />
        {!isSubmitted ? (
          <div className="emailUpdateContainer">
            <h2>Update Email Address</h2>
            {email ? (
              emailType === "notification_email" ? (
                <p className="transitionText">{messages.notification}</p>
              ) : (
                <p className="transitionText">{messages.existing}</p>
              )
            ) : (
              <p className="transitionText">{messages.new}</p>
            )}

            <div className="emailSection">
              {email && (
                <div className="currentEmailContainer">
                  <p className="currentEmail">{email}</p>
                  {emailType === "notification_email" && (
                    <button
                      className="submitButton notification_email_btn"
                      onClick={() => handleSubmit("confirm")}
                    >
                      Confirm
                    </button>
                  )}
                </div>
              )}

              {email !== "" && (
                <p className="changeEmailText">
                  If you'd like to use a different email ID, please enter it below:
                </p>
              )}

              <input
                type="email"
                value={newEmail}
                onChange={(e) => {
                  setNewEmail(e.target.value);
                  setError("");
                }}
                className="emailInput"
                placeholder="Enter your email address"
              />
              {error && <p className="errorText">{error}</p>}
            </div>

            <p className="instructionText">
              Please check your email for the instructions to set your password. Once you've set it, log
              in using your email address.
            </p>

            <button className="submitButton" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        ) : (
          <div className="successContainer">
            <h2 className="successTitle">Email Registration Successful</h2>
            <p className="successMessage">{successMessage}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default EmailUpdatePopup;
